import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FormControl } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from '@node_modules/rxjs';
import { Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import {
  ActivityDaysServiceProxy,
  AllocatedPersonnelDto,
  AllocatePersonnelForActivityDayInput,
  UpdateAllocatedPersonnelListForActivityDayInput,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-assign-personnel',
  templateUrl: './assign-personnel.component.html',
  styleUrls: ['./assign-personnel.component.less'],
})
export class AssignPersonnelComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  @ViewChild('personnelSelector', { static: true })
  personnelSelector: MatSelect;

  @Input() allowedPersonnel: any;
  @Input() activityDayId: string;
  _allocatedPersonnel: any;
  @Input() set allocatedPersonnel(value: any) {
    this._allocatedPersonnel = value;
    const allocated = this.getValueforPersonnelFormCtrl()
    this.personnelFormCtrl.setValue(allocated);
  }
  get allocatedPersonnel(): any {
    return this._allocatedPersonnel;
  }
  @Input() anyResourceSelected: boolean;

  @Input() componentMode: 'allocationSheet' | 'default' = 'default';
  @Input() controlDisabled: boolean;

  @Output()
  onAssignedCounterUpdate: EventEmitter<number> = new EventEmitter<number>();
  @Output() showActivityPanel: EventEmitter<any> = new EventEmitter<any>();

  public personnelFormCtrl: FormControl = new FormControl();
  public personnelFilterFormCtrl: FormControl = new FormControl();
  public filteredPersonnel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected _onDestroy = new Subject<void>();

  constructor(
    injector: Injector,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  isAllocationSheet() {
    return this.componentMode === 'allocationSheet';
  }

  updateTotals() {
    let personnelSum = 0;
    this.personnelFormCtrl.value.forEach(
      (item) => (personnelSum += parseInt(item.hours))
    );
    this.onAssignedCounterUpdate.emit(personnelSum);
  }

  addOrRemovePersonnel(person) {
    if (
      this.personnelFormCtrl.value.some(
        (item) => item.staffId === person.staffId
      )
    ) {
      //add to list
      this.personnelFormCtrl.value.forEach((item) => {
        if (item.staffId === person.staffId) {
          item.hours = 0;
        }
      });
      const params = new AllocatePersonnelForActivityDayInput({
        activityDayId: this.activityDayId,
        personnel: new AllocatedPersonnelDto({
          actualHours: person.hours,
          personnelId: person.staffId,
        }),
      });

      this._activityDaysServiceProxy.allocatePersonnel(params).subscribe(() => {
        this._activityDaysServiceProxy
          .getMyActivityDayForEdit(this.activityDayId)
          .subscribe((data) => {
            this.updateHours(data);
          });
      });
    } else {
      //remove from list
      this._activityDaysServiceProxy
        .removeAllocatedPersonnel(this.activityDayId, person.staffId)
        .subscribe(() => {});
    }

    this.updateTotals();
  }

  updateHours(data): void {
    let currentValue = [...this.personnelFormCtrl.value];
    const currentBackendValue =
      data.activityDay.allocatedPersonnel.allocatedPersonnel;

    currentValue.forEach((currentItem) => {
      let currentBackendItem = currentBackendValue?.filter(
        (backendItem) => backendItem.staffId === currentItem.staffId
      );
      if (currentBackendItem.length > 0) {
        currentItem.allActualHoursAssigned =
          currentBackendItem[0].allActualHoursAssigned;
        currentItem.allocatedPersonnelHoursForSupervisors =
          currentBackendItem[0].allocatedPersonnelHoursForSupervisors;
      }
    });

    this.personnelFormCtrl.setValue(currentValue);
  }

  ngAfterViewInit() {
    this.setInitialPersonnelSelectorValue();
  }

  setInitialPersonnelSelectorValue() {
    this.filteredPersonnel
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.personnelSelector.compareWith = (a: any, b: any) => {
          return a && b && a.staffId === b.staffId;
        };
      });
  }

  ngOnInit(): void {
    if (this.allowedPersonnel) {
      const allowed = [...this.allowedPersonnel].map((item) => {
        let hrs = 0;

        this.allocatedPersonnel.allocatedPersonnel.forEach((allocated) => {
          if (allocated.staffId === item.staffDetails.staffId) {
            hrs = allocated.actualHours;
          }
        });

        return {
          staffDetails: {
            contactDetails: item.staffDetails.contactDetails,
          },
          staffId: item.staffDetails.staffId,
          hours: hrs,
          allActualHoursAssigned: 0,
          allocatedPersonnelHoursForSupervisors: 0,
        };
      });

      this.allowedPersonnel = allowed;
      this.cdr.detectChanges();
    }

    if (this.allowedPersonnel) {
      this.filteredPersonnel.next(this.allowedPersonnel.slice());
    }

    if (this.allocatedPersonnel && this.allocatedPersonnel.allocatedPersonnel) {
      const allocated = this.getValueforPersonnelFormCtrl()

      this.personnelFormCtrl.setValue(allocated);
    }

    setTimeout(() => this.updateTotals(), 0);

    this.personnelFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterPersonnel();
      });

    //this.cdr.detectChanges();
  }

  getValueforPersonnelFormCtrl(){
    return [...this.allocatedPersonnel.allocatedPersonnel].map(
      (item) => {
        return {
          staffDetails: { contactDetails: item.personnelDetails },
          staffId: item.staffId,
          hours: item.actualHours,
          allActualHoursAssigned: item.allActualHoursAssigned,
          allocatedPersonnelHoursForSupervisors:
            item.allocatedPersonnelHoursForSupervisors,
        };
      }
    );
  }

  protected filterPersonnel() {
    if (!this.allowedPersonnel) {
      return;
    }

    let search = this.personnelFilterFormCtrl.value;
    if (!search) {
      this.filteredPersonnel.next(this.allowedPersonnel.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredPersonnel.next(
      this.allowedPersonnel?.filter(
        (personnel) =>
          (
            personnel.staffDetails.contactDetails.lastName +
            ' ' +
            personnel.staffDetails.contactDetails.firstName
          )
            .toLowerCase()
            .indexOf(search) > -1
      )
    );
  }

  removeItem(staffId: string) {
    this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
      if (isConfirmed) {
        const filtered = this.personnelFormCtrl.value?.filter(
          (personnel) => personnel.staffId != staffId
        );
        this.personnelFormCtrl.setValue(filtered);
        this._activityDaysServiceProxy
          .removeAllocatedPersonnel(this.activityDayId, staffId)
          .subscribe(() => {
            this.updateTotals();
          });

        this.cdr.detectChanges();
      }
    });
  }

  updateAllocatedPersonnelList() {
    const params = new UpdateAllocatedPersonnelListForActivityDayInput({
      activityDayId: this.activityDayId,
      personnelList: [...this.personnelFormCtrl.value].map((item) => {
        return new AllocatedPersonnelDto({
          actualHours: parseInt(item.hours) || 0,
          personnelId: item.staffId,
        });
      }),
    });

    this._activityDaysServiceProxy
      .updateAllocatedPersonnelList(params)
      .subscribe(() => {
        this.updateTotals();
      });
  }

  edit() {
    abp.event.trigger('app.evt.openAssignPanel', {
      activityDayId: this.activityDayId,
    });
  }

  showError(): boolean {
    const selectedPersonal = this.personnelFormCtrl?.value;
    const total = selectedPersonal && selectedPersonal.length >0 ?selectedPersonal.map(x=>x.hours).reduce((a, b) => { return a + b }):0;
    return total<=0
  }

  personnelPopupContent(content) {
    if (!content.length) return;

    let output = '';
    content.forEach((item, index) => {
      output = `${output} ${item.hours} hrs from ${item.ownerFirstName} ${item.ownerLastName}`;
      if (index + 1 < content.length) {
        output = `${output}<br />`;
      }
    });

    return output;
  }
}
